import axios from 'axios';

const getBlogCatsApi = async (langIsoCode) => {
  try {
    const url = '/Blog/cats';
    const res = await axios.get(url, {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        lang: langIsoCode
      }
    });

    return res;
  } catch (error) {
    throw error;
  }
};

export default getBlogCatsApi;
